import { Box } from '@mui/material';
import { Section } from './Section';
import { PlateCard } from './PlateCard';
import { TOOLKIT } from './copy';

const HEADING_ID = 'toolkit-title';

export function Toolkit() {
  return (
    <Section labelledBy={HEADING_ID} eyebrow={TOOLKIT.eyebrow} title={TOOLKIT.title} titleMaxWidth="26ch">
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
          gap: 3,
        }}
      >
        {TOOLKIT.tools.map((tool) => (
          <PlateCard
            key={tool.name}
            name={tool.name}
            status={tool.status}
            what={tool.what}
            forWhom={tool.forWhom}
            link={tool.link}
          />
        ))}
      </Box>
    </Section>
  );
}
